import { reduxForm } from 'redux-form';

import EditAppForm from '../../../home/components/apps/EditAppForm';
import { validate } from '../../models/EditAppForm';
export const FORM_ID = 'AdminEditAppForm';

export default reduxForm({
  form: FORM_ID,
  validate: validate,
})(EditAppForm);
